<template>
<div class="header" :class="{[`bg-${customTheme?'gradient-info':type}`]: type}">
    <div class="container-fluid">
        <div class="header-body">
            <slot></slot>
        </div>
    </div>
</div>
</template>

<script>
import configPOPTheme from '@/config/POPTheme'
export default {
    name: 'base-header',
    data() {
        return {
            customTheme: configPOPTheme || false,
        };
    },
    props: {
        type: {
            type: String,
            default: 'primary',
            description: 'Header background type'
        }
    }
}
</script>

<style>
</style>
